import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "h5 card-title" }
const _hoisted_4 = { class: "d-flex flex-row gap-3 flex-wrap" }
const _hoisted_5 = { class: "flex-basis-0 flex-grow-9 d-flex flex-column gap-3 min-w-max-content" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-redlining" }, null, -1)
const _hoisted_8 = { class: "flex-basis-0 flex-grow-3 reviewPositionResultOptionsContainer" }
const _hoisted_9 = ["disabled", "id", "value", "name", "onClick"]
const _hoisted_10 = ["for"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadedOrPlaceholder = _resolveComponent("LoadedOrPlaceholder")!
  const _component_ReviewCommentTextArea = _resolveComponent("ReviewCommentTextArea")!
  const _component_ReviewAttachmentsWidget = _resolveComponent("ReviewAttachmentsWidget")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, [
        _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.position }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.position.realmCode) + " " + _toDisplayString(_ctx.$s(_ctx.position.realmName)), 1)
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ReviewCommentTextArea, {
            disabled: this.reviewData === _ctx.loadingPlaceholder,
            modelValue: _ctx.value.comment,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.comment) = $event))
          }, null, 8, ["disabled", "modelValue"]),
          _createElementVNode("a", {
            href: _ctx.redliningLink,
            class: "text-decoration-none text-body text-end"
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('general.redlining')) + " ", 1),
            _hoisted_7
          ], 8, _hoisted_6),
          _createVNode(_component_ReviewAttachmentsWidget, {
            disabled: this.reviewData === _ctx.loadingPlaceholder,
            modelValue: _ctx.value.attachments,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.attachments) = $event)),
            deletedAttachmentIds: _ctx.value.deletedAttachmentIds,
            "onUpdate:deletedAttachmentIds": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.deletedAttachmentIds) = $event))
          }, null, 8, ["disabled", "modelValue", "deletedAttachmentIds"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultOptions, (option, optionIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "form-check",
              key: option.reviewCycleResultOptionId ?? optionIndex
            }, [
              _withDirectives(_createElementVNode("input", {
                disabled: _ctx.position === _ctx.loadingPlaceholder,
                type: "radio",
                class: "form-check-input",
                id: _ctx.$id('result' + option.reviewCycleResultOptionId ?? optionIndex),
                value: option.reviewCycleResultOptionId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.reviewCycleResultOptionId) = $event)),
                name: _ctx.$id('result'),
                onClick: ($event: any) => (this.optionChosen(option)),
                required: ""
              }, null, 8, _hoisted_9), [
                [_vModelRadio, _ctx.value.reviewCycleResultOptionId]
              ]),
              _createElementVNode("label", {
                for: _ctx.$id('result' + option.reviewCycleResultOptionId ?? optionIndex),
                class: "form-check-label"
              }, [
                _createVNode(_component_LoadedOrPlaceholder, { value: option }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$s(option.reviewCycleResultOptionName)), 1)
                  ]),
                  _: 2
                }, 1032, ["value"])
              ], 8, _hoisted_10),
              (optionIndex === (_ctx.resultOptions.length - 1))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('review.review.entry.noResultOption')), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}